// Invisible characters that commonly ride along when a value is copied out of
// Excel, Word or a chat app: zero-width spaces/joiners, BOM, word joiner,
// soft hyphen and the bidi formatting marks. They are never part of a real
// username or password but they do reach the server and fail the login.
const INVISIBLE_CHARS = /[­᠎​-\u200F\u202A-\u202E⁠-⁤\u2066-⁯﻿]/g;

// Control characters (Excel cells often carry a trailing \r or \n).
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[ --]/g;

// Unicode whitespace, including the non-breaking space Excel likes to emit.
const EDGE_WHITESPACE = /^[\s   -   　]+|[\s   -   　]+$/g;

/**
 * Strips invisible/control characters anywhere in the value and trims any
 * whitespace at either end. Use on credential inputs so a pasted value behaves
 * the same as a typed one.
 */
export const sanitizeInput = (value: any): any => {
    if (typeof value !== 'string') {
        return value;
    }

    return value
        .replace(INVISIBLE_CHARS, '')
        .replace(CONTROL_CHARS, '')
        .replace(EDGE_WHITESPACE, '');
}
